/**
 * 根据 url 解析环境
 * @returns 'prod' | 'pre' | 'daily'
 */
export function getEnv() {
    let env = 'prod'; // 线上
    if (location.host.startsWith('localhost') || location.host.startsWith('127.0.0.1')) {
        env = 'dev';
    }
    else if (location.host.endsWith('.test')) {
        // 日常
        env = 'daily';
    }
    else if (location.host.startsWith('pre-') || location.host.startsWith('uat-')) {
        // 预发
        env = 'pre';
    }
    return env;
}
/**
 * 获取用户工号
 */
export function getUserID() {
    if (typeof document === undefined) {
        return '';
    }
    if (window.__getUserId) {
        const workNo = window.__getUserId();
        if (workNo && !workNo.toLocaleLowerCase().includes('workno'))
            return workNo;
    }
    if (window.g_config && (window.g_config.workNo || window.g_config.empId)) {
        const workNo = window.g_config.workNo || window.g_config.empId;
        if (workNo && !workNo.toLowerCase().includes('workno'))
            return workNo;
    }
    var cookie = document.cookie;
    // try to get emplId from cookie
    var emplId = (/emplid=([^;]+)/i.exec(cookie) || [])[1];
    // try to get workNo from cookie
    var workNo = (/work_?no=([^;]+)/i.exec(cookie) || [])[1];
    // try to get SSO_EMPID_HASH from cookie
    var hashId = (/SSO_EMPID_HASH=([^;]+)/.exec(cookie) || /SSO_EMPID_HASH_V2=([^;]+)/.exec(cookie) || [])[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return emplId || workNo || hashId || '';
}
export const pidMapToBlankConfig = {
    '5wPa2T': {
        plugin_blank_target: '.eone-shell-header'
    },
    'iRNfMJ': {
        plugin_blank_target: '.next-shell-header'
    },
    'X46rnY': {
        plugin_blank_target: '.next-shell-header'
    },
    'XEdw8F': {
        plugin_blank_target: 'div'
    },
    'NKWHj5': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'yiEcEi': {
        plugin_blank_target: '#App'
    },
    'WS2jGC': {
        plugin_blank_target: '#App'
    },
    'TFbxNc': {
        plugin_blank_target: '#App'
    },
    '7pArjj': {
        plugin_blank_target: '#blankScreenSelector'
    },
    'SGR6Pt': {
        plugin_blank_target: '.next-shell-header'
    },
    '36Kfy4': {
        plugin_blank_target: '.next-shell-header'
    },
    'YyRTWZ': {
        plugin_blank_target: '.next-menu-header'
    },
    'wZkKAD': {
        plugin_blank_target: 'div'
    },
    'XxSCfE': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'DBC72h': {
        plugin_blank_target: '.next-shell-header'
    },
    'mJrw3t': {
        plugin_blank_target: '.app-main'
    },
    'r2iTw7': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'BNJ5FJ': {
        plugin_blank_target: 'div'
    },
    'cshDJP': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'TzXFPi': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'KaQMfz': {
        plugin_blank_target: '.kuma-primary-navigation'
    },
    'E5yZrP': {
        plugin_blank_target: '.next-shell-header'
    },
    'Z2jbZt': {
        plugin_blank_target: '.next-shell-header'
    },
    'XsMPdk': {
        plugin_blank_target: '.next-shell-header-salary'
    },
    'yRbbmX': {
        plugin_blank_target: '.next-shell-header'
    },
    'hh8msP': {
        plugin_blank_target: '.next-shell-header'
    },
    'rNsaPK': {
        plugin_blank_target: '#App'
    },
    'kNPQXW': {
        plugin_blank_target: '.next-shell-header'
    },
    'cdzGG8': {
        plugin_blank_target: '.om-nav-container'
    },
    'nHtJYP': {
        plugin_blank_target: '#App'
    },
    'WRZZNP': {
        plugin_blank_target: '#App'
    },
    'b3hzBa': {
        plugin_blank_target: '.next-shell-header'
    },
    'zBcABD': {
        plugin_blank_target: '#root'
    },
    'KBXzTB': {
        plugin_blank_target: '.hrc-content'
    },
    'zPAzG6': {
        plugin_blank_target: '#app'
    },
    '8TfA4Z': {
        plugin_blank_target: '.next-shell-header'
    },
    '3SJm8b': {
        plugin_blank_target: '.eone-shell-header'
    },
    'JPkm4G': {
        plugin_blank_target: '.next-shell-header'
    },
    '2HspGd': {
        plugin_blank_target: '.eone-shell-header'
    },
    '5bhHar': {
        plugin_blank_target: '.eone-shell-header'
    },
    'xsbwzr': {
        plugin_blank_target: '.eone-shell-header'
    },
    'amYCBx': {
        plugin_blank_target: '.eone-shell-header'
    },
    'XYfw2i': {
        plugin_blank_target: '.eone-shell-header'
    },
    'rSkX8W': {
        plugin_blank_target: '.eone-shell-header'
    },
    'T6iszD': {
        plugin_blank_target: '.eone-shell-header'
    },
    '2h3Gpr': {
        plugin_blank_target: '#designer-loader'
    },
    // '': {	// 
    // }
};
export const pidMapToPvConfig = {};
// 设置元素
export const $ = document.querySelector.bind(document);
export const setElement = (tag, selector, props, callback) => {
    const { document } = window;
    let element = $(selector);
    const shouldInsert = !element;
    element || (element = document.createElement(tag));
    for (const k in props) {
        element.setAttribute(k, props[k]);
    }
    // 如script 加载回调
    if (callback) {
        element.onload = function () {
            callback();
        };
    }
    if (shouldInsert) {
        const head = document.head || $('head');
        head && head.appendChild(element);
    }
};
